import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  ngOnInit(): void {

    console.log(this.currentPage)

      }
  title = 'Tracllo Dashboard';
  currentPage=''
  isHomePage=false

  constructor(private router:Router) {
      router.events.subscribe(event => {

        if (event instanceof NavigationEnd ) {
          this.currentPage=event.url
          if(this.currentPage.indexOf("#")!=-1){
            console.log("wabout")
            // this.router.navigate(['/'], {fragment: 'about'})
            this.isHomePage=true

          }
          else if(this.currentPage=='/'){
            this.router.navigateByUrl('/')
            this.isHomePage=true

          }
          else if(this.currentPage=='/privacy'){
            this.router.navigateByUrl('/privacy')
            this.isHomePage=true

          }
          else if(!localStorage.getItem('type')&&this.currentPage!='/'){
            this.router.navigateByUrl('/login')
            this.isHomePage=false

          }

          console.log(this.currentPage)

        }
      });
  }
}
